//@flow
// /* eslint-disable prefer-template, no-path-concat, import/unambiguous, import/no-commonjs */
/* eslint-disable camelcase */
import { drawLercUtil, getLercMaskTexture } from './draw_lerc_util';
import type Painter from "../../render/painter";

export default drawLercCompare;

const drawTypes = {
    normal: 0,
    compare: 1,
};

function getType(key) {
    return drawTypes[key] || 0;
}
function drawLercCompare(painter: Painter, sourceCache, layer, coords) {
    drawLercUtil(painter, sourceCache, layer, coords,
        {
            programName: 'lerc-compare',
            bindOtherParamFunc: bindTerrainParam
        }
    );
}
function bindTerrainParam(gl, program, layer, sourceCache, coord) {
    // compare
    gl.uniform4fv(program.uniforms.u_appear_color, layer.paint.get('appear-color').toVec4());
    gl.uniform4fv(program.uniforms.u_disappear_color, layer.paint.get('disappear-color').toVec4());

    gl.uniform1f(program.uniforms.u_diff_range_min, layer.paint.get('diff-range-min'));
    gl.uniform1f(program.uniforms.u_diff_range_max, layer.paint.get('diff-range-max'));
    gl.uniform1i(program.uniforms.u_draw_type, getType(layer.paint.get('draw-type')));
    const diffColor = layer.paint.get('diff-color');
    const increaseColor = layer.paint.get('increase-color') || diffColor;
    const decreaseColor = layer.paint.get('decrease-color') || diffColor;

    gl.uniform4fv(program.uniforms.u_increase_color, increaseColor.toVec4());
    gl.uniform4fv(program.uniforms.u_decrease_color, decreaseColor.toVec4());
    gl.uniform4fv(program.uniforms.u_same_color, layer.paint.get('same-color').toVec4());
    const compareSourceId = layer.paint.get('lerc-compare-source');
    const compareTexture = getLercMaskTexture(sourceCache, compareSourceId, coord);
    if (compareTexture) {
        // gl.uniform1f(program.uniforms.u_mask, true);
        gl.activeTexture(gl.TEXTURE4);
        gl.bindTexture(gl.TEXTURE_2D, compareTexture);
        gl.uniform1i(program.uniforms.u_texture_compare, 4);
    } else {
        // gl.uniform1f(program.uniforms.u_mask, false);
        gl.activeTexture(gl.TEXTURE4);
        gl.bindTexture(gl.TEXTURE_2D, null);
        gl.uniform1i(program.uniforms.u_texture_compare, 4);
    }
}
